module.exports = __webpack_public_path__ + "static/media/NoProjects.58cfb628.jpg";